import { Loader } from '@components/loader';
import { DashboardProps } from './types';
import { cn } from '@utils/cn';

export const Dashboard = ({ children, isLoading, className }: DashboardProps) => (
  <section className={cn('relative grid h-fit w-full grid-cols-1', className && className)}>
    {isLoading ? (
      <header className="rounded-lg bg-white px-6 py-4">
        <Loader local />
      </header>
    ) : (
      children
    )}
  </section>
);
